module.exports = ".close-button {\n  float: right;\n  top: -22px;\n  right: -22px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dialogs/confirm/confirm.component.scss
// module id = ./src/app/dialogs/confirm/confirm.component.scss
// module chunks = main